/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */
/* Env fallback and API_BASE added for app config and single source for backend URL */

const env = typeof import.meta !== 'undefined' ? (import.meta as any).env : undefined;
const isProd = env?.MODE === 'production';

/** Derive project ID from URL if set (e.g. https://xxxx.supabase.co -> xxxx). */
function projectIdFromUrl(url: string | undefined): string | undefined {
  if (!url) return undefined;
  try {
    const u = new URL(url);
    return u.hostname.split('.')[0] || undefined;
  } catch {
    return undefined;
  }
}

export const projectId = (() => {
  const v = env?.VITE_SUPABASE_PROJECT_ID ?? projectIdFromUrl(env?.VITE_SUPABASE_URL);
  if (isProd && !v) throw new Error('VITE_SUPABASE_PROJECT_ID or VITE_SUPABASE_URL is required in production');
  return v || 'ytpveenalokctvmjcfpi';
})();
export const publicAnonKey = (() => {
  const v = env?.VITE_SUPABASE_ANON_KEY;
  if (isProd && !v) throw new Error('VITE_SUPABASE_ANON_KEY is required in production');
  return v || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl0cHZlZW5hbG9rY3R2bWpjZnBpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk0NjQ0MTgsImV4cCI6MjA4NTA0MDQxOH0.DUVdo-Sc8QWtuFdPbI-vCPvjWNljnpVKKvF7d2C-jrM';
})();

/** Base URL for public/general Edge Function calls (backwards compatible default). */
export const API_BASE = `https://${projectId}.supabase.co/functions/v1/talentfunn-server`;
/** Base URL for authenticated/secure Edge Function calls (JWT-verified at gateway). */
export const API_SECURE_BASE = `https://${projectId}.supabase.co/functions/v1/talentfunn-secure`;
/** Alias used for explicitly public/auth-recovery endpoints. */
export const API_PUBLIC_BASE = API_BASE;

if (isProd) {
  const missing: string[] = [];
  if (!env?.VITE_NEXI_CHECKOUT_JS_URL) missing.push('VITE_NEXI_CHECKOUT_JS_URL');
  if (!env?.VITE_NEXI_CHECKOUT_KEY) missing.push('VITE_NEXI_CHECKOUT_KEY');
  if (missing.length > 0) {
    throw new Error(`${missing.join(', ')} is required in production. Set it in your build/deploy environment.`);
  }
}
